export default __webpack_public_path__ + "static/media/logo@2x.70358c5f.png";